<div class="w-full h-[340px] overflow-visible">

    <canvas
        #chartCanvas
        (click)="onChartClick($event)"
    >
    </canvas>

</div>